import { atom } from "recoil";

const openHistoryAtom = atom({
  key: "openHistoryState",
  default: false,
});

export default openHistoryAtom;
